module.exports = __webpack_public_path__ + "img/SoftwareCopyright_2.92b8a5a1.png";